<script>
import BaseView from "@/mixins/BaseView.vue";
import TrucksList from "@/views/fleets/components/TrucksList.vue";
import TrucksListSearchForm from "@/views/fleets/components/TrucksListSearchForm.vue";
import LinkButton from "@/components/buttons/LinkButton.vue";
import PageHeader from "@/components/header/PageHeader.vue";
import OmniTooltip from "@/components/omni/OmniTooltip.vue";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto.ts";

export default {
  name: "TrucksPage",
  components: { OmniTooltip, PageHeader, LinkButton, TrucksListSearchForm, TrucksList },
  mixins: [BaseView],
  data() {
    return {
      perm: "trucks",
      searchParams: {},
    };
  },
  computed: {
    hasAccessToCreate() {
      return this.hasAccess(DispatcherPermissionValue.EditOrCreateTruck);
    },
  },
  created() {
    this.setTitle(this.$t("trucks.trucks"));
  },
  methods: {
    search(params) {
      this.searchParams = { ...params };
    },
  },
};
</script>

<template>
  <v-container :fluid="true" class="pt-6 pb-10 pl-6 pr-6 height-100 trucks-page">
    <page-header :header="$t('trucks.trucks')">
      <template #suffix>
        <omni-tooltip :disabled="hasAccessToCreate">
          <template #activator>
            <link-button
              id="create-truck-btn"
              :disabled="!hasAccessToCreate"
              :to="{ name: 'truck-edit', params: { id: 'new' } }"
              color="success"
            >
              {{ $t("general.create-new") }}
            </link-button>
          </template>

          {{ $t("permission.create-truck") }}
        </omni-tooltip>
      </template>
    </page-header>

    <trucks-list-search-form @search="search" />
    <trucks-list
      :available-columns="['name', 'status', 'driver', 'size', 'available', 'current']"
      :search-params="searchParams"
    />
  </v-container>
</template>

<style lang="scss" scoped>
.trucks-page {
  & > .v-card {
    background: transparent;
  }
}
</style>
